<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="33" viewBox="0 0 54 33">
    <defs>
        <path id="kuntvlwypb" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <path id="vcuclxr0kd" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <path id="3r4ih2c0if" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
        <linearGradient id="2ygg9n87ia" x1="0%" x2="100%" y1="68.673%" y2="31.327%">
            <stop offset="0%" stop-color="#0168B4"/>
            <stop offset="18.838%" stop-color="#0168B4"/>
            <stop offset="50.596%" stop-color="#B8383C"/>
            <stop offset="100%" stop-color="#D90338"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path fill="url(#2ygg9n87ia)" d="M1 0h52c.552 0 1 .448 1 1v31c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1z" transform="translate(-5 -8) translate(5 8) matrix(-1 0 0 1 54 0)"/>
      <g fill="#fff" transform="translate(12.5, 4.5)">
        <polygon  points="0 4.62972222 28 4.62972222 28 9.25925926e-05 0 9.25925926e-05"></polygon>
        <g transform="translate(1.866667, 5.947315)">
          <path d="M10.34824,18.5185185 L8.48157333,18.5185185 C2.57544,12.537037 14.3867733,6.55555556 8.48157333,0.574074074 L10.34824,0.574074074 C16.25344,6.55555556 4.44397333,12.537037 10.34824,18.5185185" id="Fill-2"></path>
          <path d="M4.21502667,18.5185185 L2.34836,18.5185185 C-3.55684,12.537037 8.25262667,6.55555556 2.34836,0.574074074 L4.21502667,0.574074074 C10.1202267,6.55555556 -1.69017333,12.537037 4.21502667,18.5185185" id="Fill-4"></path>
          <path d="M16.4814533,18.5185185 L14.6147867,18.5185185 C8.71052,12.537037 20.5190533,6.55555556 14.6147867,0.574074074 L16.4814533,0.574074074 C22.3866533,6.55555556 10.5762533,12.537037 16.4814533,18.5185185" id="Fill-6"></path>
          <path d="M22.6145733,18.5185185 L20.7479067,18.5185185 C14.84364,12.537037 26.6521733,6.55555556 20.7479067,0.574074074 L22.6145733,0.574074074 C28.5197733,6.55555556 16.7093733,12.537037 22.6145733,18.5185185" id="Fill-8"></path>
        </g>
      </g>
    </g>
</svg>
